export const SLACK_TRAVEL_SUPPORT_SOURCE = 'travel-cms-ms';
